export const formatDebitAndCreditCardTypes = ({ supportedFundingSources }) => {
  const issuersObject = supportedFundingSources
    .reduce((accum, item) => {
      accum = [...accum, ...item.issuers];
      return accum;
    }, [])
    .reduce((accum, issuer) => {
      if (!accum[issuer.name] || !issuer?.usage?.includes('DEBIT')) {
        const { usage, ...otherProps } = issuer;
        accum[issuer.name] = otherProps;
      }
      return accum;
    }, {});

  const issuersArr = Object.values(issuersObject)
    .sort((a, b) => a.rank > b.rank)
    .filter(issuer => {
      return issuer.name;
    });

  return issuersArr;
};
